export const environment = {
  production: false,
  baseUrl: 'https://api-new.luudu.com',
  formspeeEndpoint: 'https://formspree.io/f/mwkganjd',
};
